import { ErrorMessage } from "@/components/ui/error";
import { useCreateWhatsAppForwarding } from "@/queries/whatsapp-forwardings/create";
import { useDeleteWhatsAppForwarding } from "@/queries/whatsapp-forwardings/delete";
import { useGetAllWhatsAppForwardings } from "@/queries/whatsapp-forwardings/get-all";
import { useUpdateWhatsAppForwarding } from "@/queries/whatsapp-forwardings/update";
import { WhatsAppForwarding } from "./whatsapp-forwarding";

export const WhatsAppForwardingContainer = () => {
  const { whatsappForwardings, loading, error } =
    useGetAllWhatsAppForwardings();

  const { createWhatsAppForwarding } = useCreateWhatsAppForwarding();
  const { deleteWhatsAppForwarding } = useDeleteWhatsAppForwarding();
  const { updateWhatsAppForwarding } = useUpdateWhatsAppForwarding();

  const handleCreateWhatsAppForwarding = async ({
    phoneNumber,
    name,
  }: {
    phoneNumber: string;
    name: string;
  }) => {
    await createWhatsAppForwarding({
      phoneNumber,
      name,
    });
  };

  const handleDeleteWhatsAppForwarding = (whatsappForwardingId: string) => {
    return deleteWhatsAppForwarding(whatsappForwardingId);
  };

  const handleUpdateWhatsAppForwarding = async ({
    whatsappForwardingId,
    phoneNumber,
    name,
    onboardingState,
  }: {
    whatsappForwardingId: string;
    phoneNumber?: string;
    name?: string;
    onboardingState?: string;
  }) => {
    await updateWhatsAppForwarding({
      whatsappForwardingId,
      phoneNumber,
      name,
      onboardingState,
    });
  };

  if (error) {
    return (
      <div className="flex justify-center items-center h-full p-4">
        <ErrorMessage />
      </div>
    );
  }

  return (
    <WhatsAppForwarding
      whatsappForwardings={whatsappForwardings}
      loading={loading}
      onDeleteWhatsAppForwarding={handleDeleteWhatsAppForwarding}
      onUpdateWhatsAppForwarding={handleUpdateWhatsAppForwarding}
      onCreateWhatsAppForwarding={handleCreateWhatsAppForwarding}
    />
  );
};
